export default __webpack_public_path__ + "static/media/ltv_dark_logo_2.971fa4ae.png";